export default __webpack_public_path__ + "static/media/battery-full24x24.a7bb7c82.svg";